module.exports = __webpack_public_path__ + "images/opel_smallbfcaf05c5cf0aa1b6ce3d102077fd66a.png";